<link rel="ractive" href="./dropdown-icon.html" name="c-dropdown-icon">

<header class="c-header {{#if additionalClasses}}{{additionalClasses}}{{/if}}">
	<nav class="navbar navbar-default navbar-filled">
		<div class="container-fluid container-mw">
			<div class="navbar-header">
				<a class="main-logo" href="/" on-click="@this.fire('main-logo-click')">
					<!--
						Looking for the logo?
						Get all versions here: https://github.com/jsdelivr/globalping-media
					-->
					{{#if mainLogoName}}
						<img width="138" height="34" src="{{@shared.assetsHost}}/img/{{mainLogoName}}" title="Globalping">
					{{else}}
						<img width="138" height="34" src="{{@shared.assetsHost}}/img/globalping.svg" title="Globalping">
					{{/if}}
				</a>

				<a class="main-logo_text globalping" href="https://www.jsdelivr.com">by jsDelivr</a>

				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#main-navbar" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>

			<div class="collapse navbar-collapse shadow-md" id="main-navbar">
				<ul class="nav navbar-nav navbar-right {{!@shared.actualPath ? 'navbar-hidden' : 'about-navbar-right'}}">
					<li><a href="/cli">CLI</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0">
							Integrations <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/slack"><c-dropdown-icon src="{{@shared.assetsHost}}/img/slack-icon-dark.svg" size="12px"></c-dropdown-icon>Slack App</a></li>
							<li><a href="/discord"><c-dropdown-icon src="{{@shared.assetsHost}}/img/discord-icon-dark.svg" size="12px" top="1px"></c-dropdown-icon>Discord App</a></li>
							<li><a href="/docs/api.globalping.io" class="router-ignore"><c-dropdown-icon src="{{@shared.assetsHost}}/img/code-icon-dark.svg" size="12px"></c-dropdown-icon>REST API</a></li>
							<li role="separator" class="divider"></li>
							<li><a href="/integrations"><c-dropdown-icon src="{{@shared.assetsHost}}/img/list-icon-dark.svg" size="12px"></c-dropdown-icon>All Integrations</a></li>
						</ul>
					</li>
					<li><a href="/credits">Credits</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0">
							Explore <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/network"><c-dropdown-icon src="{{@shared.assetsHost}}/img/radio.svg" size="14px"></c-dropdown-icon>Probe Network</a></li>
							<li><a href="/network-providers"><c-dropdown-icon class="fa fa-server" size="12px" top="2px"></c-dropdown-icon>Network Providers</a></li>
							<li><a href="/leaderboard"><c-dropdown-icon class="fa fa-trophy" size="12px" top="1px"></c-dropdown-icon>User Leaderboard</a></li>
						</ul>
					</li>
					<li><a href="/sponsors">Sponsors</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0">
							The Project <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/about-us">About Us</a></li>
							<li role="separator" class="divider"></li>
							<li><a target="_blank" href="https://blog.globalping.io" class="router-ignore">Blog <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a target="_blank" href="https://github.com/jsdelivr/globalping" class="router-ignore">GitHub <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
						</ul>
					</li>
					<li>
						<a target="_blank" rel="noopener noreferrer" href="https://twitter.com/jsDelivr" title="Twitter">
							<i class="fa fa-twitter" aria-hidden="true"></i>
							<span class="icon-label-mobile">Twitter</span>
						</a>
					</li>
					{{#unless hideAuthentication}}
						{{#if @shared.user}}
							<li class="dashboard-section">
								<a href="https://dash.globalping.io" class="btn btn-dash">
									<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
										<path d="M8.33333 2.5H2.5V8.33333H8.33333V2.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M17.5 2.5H11.6667V8.33333H17.5V2.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg> Dashboard
								</a>

								<div class="dropdown">
									<button type="button" class="btn dropdown-toggle hidden-xs hidden-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<svg style="vertical-align: middle;" fill="currentColor" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
											<g id="user"><path d="M12,12.25A3.75,3.75,0,1,1,15.75,8.5,3.75,3.75,0,0,1,12,12.25Zm0-6A2.25,2.25,0,1,0,14.25,8.5,2.25,2.25,0,0,0,12,6.25Z"/>
												<path d="M19,19.25a.76.76,0,0,1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25,1.3-6.25,3.25a.75.75,0,0,1-1.5,0c0-4.75,5.43-4.75,7.75-4.75s7.75,0,7.75,4.75A.76.76,0,0,1,19,19.25Z"/>
											</g>
										</svg>
										<span class="caret"></span>
										<span class="sr-only">Toggle Dropdown</span>
									</button>
									<ul class="dropdown-menu">
										<li class="current-user">{{@shared.user.github_username}}</li>
										<li role="separator" class="divider"></li>
										<li><a on-click="@global.app.signOut()">Sign Out</a></li>
									</ul>
								</div>
							</li>
							<li class="hidden-md hidden-lg"><a on-click="@global.app.signOut()"><i class="fa fa-sign-out" style="margin-right: 8px;"></i>Sign Out</a></li>
						{{elseif @shared.user === null}}
							<li class="dashboard-section">
								<a class="btn btn-sign-in" on-click="@global.app.signIn()">
									<i class="fa fa-sign-in hidden-md hidden-lg" style="margin-right: 8px;"></i>
									Sign in
									<span class="hidden-md hidden-lg">&nbsp;with GitHub</span><i class="fa fa-github hidden-xs hidden-sm" style="margin-left: 8px;"></i>
								</a>
							</li>
						{{else}}
							<li class="dashboard-section"></li>
						{{/if}}
					{{/unless}}
				</ul>
			</div>
		</div>
	</nav>
</header>

<script>
	component.exports = {
		data () {
			return {};
		},
	};
</script>
